import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "../../App.css";
import "./Grovfodret.css";
import { setFormErrors } from "../../helpers/util";
import FormElement from "../../components/FormElement/FormElement";

import InputSection from "../../components/form-elements/InputSection";
import Label from "../../components/form-elements/Label";
import InputWrapper from "../../components/form-elements/InputWrapper";
import { Input } from "../../components/form-elements/Input";
import { LabelInput } from "../../components/form-elements/LabelInput";
import ResultSection from "../../components/results/ResultSection";
import Error from "../../components/form-elements/Error";
import SubSection from "../../components/form-elements/SubSection";
import HiddenToolFields from "../../components/HiddenToolFields";
import LabelInputWrapper from "../../components/form-elements/LabelInputWrapper";
import ResultWrapper from "../../components/results/ResultWrapper";
import ToolHeader from "../../components/ToolHeader/ToolHeader";
import useSavedResults from "../../helpers/useSavedResults";
import ActionsBar from "../../components/ActionsBar/ActionsBar";
import Wrapper from "../../components/Wrapper/Wrapper";
import FormSection from "../../components/FormSection/FormSection";
import InputColumn from "../../components/InputColumn/InputColumn";

const schema = yup.object({
  B3: yup.string().required("Obligatoriskt"), // B3 Användarens namn
  D3: yup.string().required("Obligatoriskt"), // D3 Namn på beräkningen
  D5: yup
    .number()
    .min(1, "Numret behöver vara större än 0")
    .typeError("Endast numeriskt värde tillåtet")
    .required("Obligatoriskt"), // D5:  Totalt brukad areal exkl betesmark
  H5: yup
    .number()
    .typeError("Endast numeriskt värde tillåtet")
    .required("Obligatoriskt"), // H5: varav grovfoder
  D6: yup
    .number()
    .min(1, "Numret behöver vara större än 0")
    .typeError("Endast numeriskt värde tillåtet")
    .required("Obligatoriskt"), // D6: Behov ts-skörd grovfoder totalt exkl bete
  H7: yup
    .number()
    .typeError("Endast numeriskt värde tillåtet")
    .min(1, "Numret behöver vara större än 0")
    .max(100, "Max 100")
    .required("Obligatoriskt"), // H7: Ts-halt skörd (snitt)
  D8: yup.number().typeError("Endast numeriskt värde tillåtet"), // D8: Arbetstid totalt grovfoder fram till och med lager
  H8: yup
    .number()
    .typeError("Endast numeriskt värde tillåtet")
    .min(1, "Numret behöver vara större än 0"), //  H8: Traktortimmar grovfoder
  D9: yup.number().typeError("Endast numeriskt värde tillåtet"), // D9: Arbetskostnad

  // Förnödenheter och arealkostnad per år
  F13: yup.number().typeError("Endast numeriskt värde tillåtet"), // F13: Areal/Arrendekostnad totalt för all areal
  F14: yup.number().typeError("Endast numeriskt värde tillåtet"), // F14: Utsäde och frö till grovfoder
  F15: yup.number().typeError("Endast numeriskt värde tillåtet"), // F15: Handelsgödsel grovfoder
  F16: yup.number().typeError("Endast numeriskt värde tillåtet"), // F16: Kalk total kostnad per år
  F17: yup.number().typeError("Endast numeriskt värde tillåtet"), // F17: Bekämpningsmedel totalt
  F18: yup.number().typeError("Endast numeriskt värde tillåtet"), // F18: Tillsatsmedel grovfoder
  F19: yup.number().typeError("Endast numeriskt värde tillåtet"), // F19: Plast och nät
  F20: yup.number().typeError("Endast numeriskt värde tillåtet"), // F20: Analyser och övriga kostnader grovfoder

  B21: yup.string(), // B21: Optional field 1 label
  F21: yup.number().typeError("Endast numeriskt värde tillåtet"), // F21: Optional field 1

  F22: yup.number().typeError("Endast numeriskt värde tillåtet"), // F22: Maskinförsäkring

  B23: yup.string(), // B23: Optional field 2 label
  F23: yup.number().typeError("Endast numeriskt värde tillåtet"), // F23: Optional field 2

  // Maskinkostnader
  F29: yup.number().typeError("Endast numeriskt värde tillåtet"), // F29: Värdeminskning maskiner per år
  B30: yup.string(), // B30: Optional field 3 label
  F30: yup.number().typeError("Endast numeriskt värde tillåtet"), // F30: Optional field 3
  B31: yup.string(), // B31: Optional field 4 label
  F31: yup.number().typeError("Endast numeriskt värde tillåtet"), // F31: Optional field 4

  F33: yup.number().typeError("Endast numeriskt värde tillåtet"), // F33: Diesel lantbruk exklusive entr. skog och inomgård
  I33: yup
    .number()
    .typeError("Endast numeriskt värde tillåtet")
    .min(0.01, "Numret behöver vara större än 0")
    .required("Obligatoriskt"), // I33: Ange dieselpris efter återbetalning av skatt.

  F36: yup.number().typeError("Endast numeriskt värde tillåtet"), // F36: Underhåll Maskiner per år
  B37: yup.string(), // B37: Optional field 3 label
  F37: yup.number().typeError("Endast numeriskt värde tillåtet"), // F37: Optional field 3
  B38: yup.string(), // B38: Optional field 4 label
  F38: yup.number().typeError("Endast numeriskt värde tillåtet"), // F38: Optional field 4

  F40: yup.number().typeError("Endast numeriskt värde tillåtet"), // F40: Kapitalkostnad maskiner - ränta

  F42: yup.number().typeError("Endast numeriskt värde tillåtet"), // F42 Inköpta körslor grovfoder
  I42: yup.number().typeError("Endast numeriskt värde tillåtet"), // I42: Disel Ange en uppskattad mäng diesel som förbrukats av den som utför körslor på din gård

  // Summa produktionskostnad grovfoder fält utan stöd
  F52: yup.number().typeError("Endast numeriskt värde tillåtet"), // F52: Arealknutna stöd totalt
});

function Grovfodret() {
  const [serverMessages, setServerMessages] = useState([]);
  const { displaySavedAlert } = useSavedResults();
  const [hasResults, setHasResults] = useState(
    window.wpObject.tool_data != null
  );

  const defaultValues = {
    B3:
      window.wpObject?.tool_data?.data?.B3 != null
        ? window.wpObject.tool_data.data.B3
        : "", // B3
    D3:
      window.wpObject?.tool_data?.data?.D3 != null
        ? window.wpObject.tool_data.data.D3
        : "", // D3
    D5:
      window.wpObject?.tool_data?.data?.D5 != null
        ? window.wpObject.tool_data.data.D5
        : 0, // D5:  Totalt brukad areal exkl betesmark
    H5:
      window.wpObject?.tool_data?.data?.H5 != null
        ? window.wpObject.tool_data.data.H5
        : 0, // H5: varav grovfoder
    D6:
      window.wpObject?.tool_data?.data?.D6 != null
        ? window.wpObject.tool_data.data.D6
        : 0, // D6: Behov ts-skörd grovfoder totalt exkl bete

    H7:
      window.wpObject?.tool_data?.data?.H7 != null
        ? window.wpObject.tool_data.data.H7
        : 0, // H7: Ts-halt skörd (snitt)

    D8:
      window.wpObject?.tool_data?.data?.D8 != null
        ? window.wpObject.tool_data.data.D8
        : 0, // D8: Arbetstid totalt grovfoder fram till och med lager
    H8:
      window.wpObject?.tool_data?.data?.H8 != null
        ? window.wpObject.tool_data.data.H8
        : 0, //  H8: Traktortimmar grovfoder
    D9:
      window.wpObject?.tool_data?.data?.D9 != null
        ? window.wpObject.tool_data.data.D9
        : 0, // D9: Arbetskostnad

    // Förnödenheter och arealkostnad per år
    F13:
      window.wpObject?.tool_data?.data?.F13 != null
        ? window.wpObject.tool_data.data.F13
        : 0, // F13: Areal/Arrendekostnad totalt för all areal
    F14:
      window.wpObject?.tool_data?.data?.F14 != null
        ? window.wpObject.tool_data.data.F14
        : 0, // F14: Utsäde och frö till grovfoder
    F15:
      window.wpObject?.tool_data?.data?.F15 != null
        ? window.wpObject.tool_data.data.F15
        : 0, // F15: Handelsgödsel grovfoder
    F16:
      window.wpObject?.tool_data?.data?.F16 != null
        ? window.wpObject.tool_data.data.F16
        : 0, // F16: Kalk total kostnad per år
    F17:
      window.wpObject?.tool_data?.data?.F17 != null
        ? window.wpObject.tool_data.data.F17
        : 0, // F17: Bekämpningsmedel totalt
    F18:
      window.wpObject?.tool_data?.data?.F18 != null
        ? window.wpObject.tool_data.data.F18
        : 0, // F18: Tillsatsmedel grovfoder
    F19:
      window.wpObject?.tool_data?.data?.F19 != null
        ? window.wpObject.tool_data.data.F19
        : 0, // F19: Plast och nät
    F20:
      window.wpObject?.tool_data?.data?.F20 != null
        ? window.wpObject.tool_data.data.F20
        : 0, // F20: Analyser och övriga kostnader grovfoder

    B21:
      window.wpObject?.tool_data?.data?.B21 != null
        ? window.wpObject.tool_data.data.B21
        : "", // B21: Optional field 1 label
    F21:
      window.wpObject?.tool_data?.data?.F21 != null
        ? window.wpObject.tool_data.data.F21
        : 0, // F21: Optional field 1

    F22:
      window.wpObject?.tool_data?.data?.F22 != null
        ? window.wpObject.tool_data.data.F22
        : 0, // F22: Maskinförsäkring

    B23:
      window.wpObject?.tool_data?.data?.B23 != null
        ? window.wpObject.tool_data.data.B23
        : "", // B23: Optional field 2 label
    F23:
      window.wpObject?.tool_data?.data?.F23 != null
        ? window.wpObject.tool_data.data.F23
        : 0, // F23: Optional field 2

    // Maskinkostnader
    F29:
      window.wpObject?.tool_data?.data?.F29 != null
        ? window.wpObject.tool_data.data.F29
        : 0, // F29: Värdeminskning maskiner per år
    B30:
      window.wpObject?.tool_data?.data?.B30 != null
        ? window.wpObject.tool_data.data.B30
        : "", // B30: Optional field 3 label
    F30:
      window.wpObject?.tool_data?.data?.F30 != null
        ? window.wpObject.tool_data.data.F30
        : 0, // F30: Optional field 3
    B31:
      window.wpObject?.tool_data?.data?.B31 != null
        ? window.wpObject.tool_data.data.B31
        : "", // B31: Optional field 4 label
    F31:
      window.wpObject?.tool_data?.data?.F31 != null
        ? window.wpObject.tool_data.data.F31
        : 0, // F31: Optional field 4

    F33:
      window.wpObject?.tool_data?.data?.F33 != null
        ? window.wpObject.tool_data.data.F33
        : 0, // F33: Diesel lantbruk exklusive entr. skog och inomgård
    I33:
      window.wpObject?.tool_data?.data?.I33 != null
        ? window.wpObject.tool_data.data.I33
        : 0, // I33: Ange dieselpris efter återbetalning av skatt.

    F36:
      window.wpObject?.tool_data?.data?.F36 != null
        ? window.wpObject.tool_data.data.F36
        : 0, // F36: Underhåll Maskiner per år
    B37:
      window.wpObject?.tool_data?.data?.B37 != null
        ? window.wpObject.tool_data.data.B37
        : "", // B37: Optional field 3 label
    F37:
      window.wpObject?.tool_data?.data?.F37 != null
        ? window.wpObject.tool_data.data.F37
        : 0, // F37: Optional field 3
    B38:
      window.wpObject?.tool_data?.data?.B38 != null
        ? window.wpObject.tool_data.data.B38
        : "", // B38: Optional field 4 label
    F38:
      window.wpObject?.tool_data?.data?.F38 != null
        ? window.wpObject.tool_data.data.F38
        : 0, // F38: Optional field 4

    F40:
      window.wpObject?.tool_data?.data?.F40 != null
        ? window.wpObject.tool_data.data.F40
        : 0, // F40: Kapitalkostnad maskiner - ränta

    F42:
      window.wpObject?.tool_data?.data?.F42 != null
        ? window.wpObject.tool_data.data.F42
        : 0, // F42 Inköpta körslor grovfoder
    I42:
      window.wpObject?.tool_data?.data?.I42 != null
        ? window.wpObject.tool_data.data.I42
        : 0, // I42: Disel Ange en uppskattad mäng diesel som förbrukats av den som utför körslor på din gård

    // Summa produktionskostnad grovfoder fält utan stöd
    F52:
      window.wpObject?.tool_data?.data?.F52 != null
        ? window.wpObject.tool_data.data?.F52
        : 0, // F52: Arealknutna stöd totalt
  };

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const form = useRef(null);
  const [result, setResult] = useState({
    B3:
      window.wpObject?.tool_data?.data?.B3 != null
        ? window.wpObject?.tool_data?.data?.B3
        : "",
    D3:
      window.wpObject?.tool_data?.data?.D3 != null
        ? window.wpObject?.tool_data?.data?.D3
        : "",
    B21:
      window.wpObject?.tool_data?.data?.B21 != null
        ? window.wpObject?.tool_data?.data?.B21
        : "",
    B23:
      window.wpObject?.tool_data?.data?.B23 != null
        ? window.wpObject?.tool_data?.data?.B23
        : "",
    B30:
      window.wpObject?.tool_data?.data?.B30 != null
        ? window.wpObject?.tool_data?.data?.B30
        : "",
    B31:
      window.wpObject?.tool_data?.data?.B31 != null
        ? window.wpObject?.tool_data?.data?.B31
        : "",
    B37:
      window.wpObject?.tool_data?.data?.B37 != null
        ? window.wpObject?.tool_data?.data?.B37
        : "",
    B38:
      window.wpObject?.tool_data?.data?.B38 != null
        ? window.wpObject?.tool_data?.data?.B38
        : "",
    I5:
      window.wpObject?.tool_data?.data?.I5 != null
        ? window.wpObject?.tool_data?.data?.I5
        : 0,
    H6:
      window.wpObject?.tool_data?.data?.H6 != null
        ? window.wpObject?.tool_data?.data?.H6
        : 0, // skörd i kg blöt vara
    D7:
      window.wpObject?.tool_data?.data?.D7 != null
        ? window.wpObject?.tool_data?.data?.D7
        : 0, //Ts-skörd grovfoder per ha
    I8:
      window.wpObject?.tool_data?.data?.I8 != null
        ? window.wpObject?.tool_data?.data?.I8
        : 0, // tim/ha grovfoder

    // Kostnad per kg ts
    H13:
      window.wpObject?.tool_data?.data?.H13 != null
        ? window.wpObject?.tool_data?.data?.H13
        : 0, // kr/kg ts
    H14:
      window.wpObject?.tool_data?.data?.H14 != null
        ? window.wpObject?.tool_data?.data?.H14
        : 0, // kr/kg ts
    H15:
      window.wpObject?.tool_data?.data?.H15 != null
        ? window.wpObject?.tool_data?.data?.H15
        : 0, // kr/kg ts
    H16:
      window.wpObject?.tool_data?.data?.H16 != null
        ? window.wpObject?.tool_data?.data?.H16
        : 0, // kr/kg ts
    H17:
      window.wpObject?.tool_data?.data?.H17 != null
        ? window.wpObject?.tool_data?.data?.H17
        : 0, // kr/kg ts
    H18:
      window.wpObject?.tool_data?.data?.H18 != null
        ? window.wpObject?.tool_data?.data?.H18
        : 0, // kr/kg ts
    H19:
      window.wpObject?.tool_data?.data?.H19 != null
        ? window.wpObject?.tool_data?.data?.H19
        : 0, // kr/kg ts
    H20:
      window.wpObject?.tool_data?.data?.H20 != null
        ? window.wpObject?.tool_data?.data?.H20
        : 0, // kr/kg ts
    H21:
      window.wpObject?.tool_data?.data?.H21 != null
        ? window.wpObject?.tool_data?.data?.H21
        : 0, // kr/kg ts
    H22:
      window.wpObject?.tool_data?.data?.H22 != null
        ? window.wpObject?.tool_data?.data?.H22
        : 0, // kr/kg ts
    H23:
      window.wpObject?.tool_data?.data?.H23 != null
        ? window.wpObject?.tool_data?.data?.H23
        : 0, // kr/kg ts

    // Summa förnödenheter och arealkostnad
    F25:
      window.wpObject?.tool_data?.data?.F25 != null
        ? window.wpObject?.tool_data?.data?.F25
        : 0,
    H25:
      window.wpObject?.tool_data?.data?.H25 != null
        ? window.wpObject?.tool_data?.data?.H25
        : 0,

    // Kostnad per kg ts
    H29:
      window.wpObject?.tool_data?.data?.H29 != null
        ? window.wpObject?.tool_data?.data?.H29
        : 0, // kr/kg ts
    H30:
      window.wpObject?.tool_data?.data?.H30 != null
        ? window.wpObject?.tool_data?.data?.H30
        : 0, // kr/kg ts
    H31:
      window.wpObject?.tool_data?.data?.H31 != null
        ? window.wpObject?.tool_data?.data?.H31
        : 0, // kr/kg ts
    H33:
      window.wpObject?.tool_data?.data?.H33 != null
        ? window.wpObject?.tool_data?.data?.H33
        : 0, // kr/kg ts
    H36:
      window.wpObject?.tool_data?.data?.H36 != null
        ? window.wpObject?.tool_data?.data?.H36
        : 0, // kr/kg ts
    H37:
      window.wpObject?.tool_data?.data?.H37 != null
        ? window.wpObject?.tool_data?.data?.H37
        : 0, // kr/kg ts
    H38:
      window.wpObject?.tool_data?.data?.H38 != null
        ? window.wpObject?.tool_data?.data?.H38
        : 0, // kr/kg ts
    H40:
      window.wpObject?.tool_data?.data?.H40 != null
        ? window.wpObject?.tool_data?.data?.H40
        : 0, // kr/kg ts
    H42:
      window.wpObject?.tool_data?.data?.H42 != null
        ? window.wpObject?.tool_data?.data?.H42
        : 0, // kr/kg ts

    //Diesel lantbruk exklusive entr. skog och inomgård
    D33:
      window.wpObject?.tool_data?.data?.D33 != null
        ? window.wpObject?.tool_data?.data?.D33
        : 0, //  l/tim

    // Summa maskinkostnader grovfoder fält till och med lager
    H44:
      window.wpObject?.tool_data?.data?.H44 != null
        ? window.wpObject?.tool_data?.data?.H44
        : 0, //

    // Summa produktionskostnad grovfoder fält till och med lager exkl arbete
    H46:
      window.wpObject?.tool_data?.data?.H46 != null
        ? window.wpObject?.tool_data?.data?.H46
        : 0, // kr/kg ts

    // Arbetskostnad
    F48:
      window.wpObject?.tool_data?.data?.F48 != null
        ? window.wpObject?.tool_data?.data?.F48
        : 0, // KR
    H48:
      window.wpObject?.tool_data?.data?.H48 != null
        ? window.wpObject?.tool_data?.data?.H48
        : 0, // kr/kg ts

    // Summa produktionskostnad grovfoder fält utan stöd
    H50:
      window.wpObject?.tool_data?.data?.H50 != null
        ? window.wpObject?.tool_data?.data?.H50
        : 0, // kr/kg ts

    H52:
      window.wpObject?.tool_data?.data?.H52 != null
        ? window.wpObject?.tool_data?.data?.H52
        : 0, // Arealknutna stöd totalt - kr/kg ts

    H54:
      window.wpObject?.tool_data?.data?.H54 != null
        ? window.wpObject?.tool_data?.data?.H54
        : 0, // Summa produktionskostnad grovfoder fält minskad med arealknutna stöd	- kr/kg ts

    // Dieselförbukning totalt och per ha grovfoder till och med lager
    F56:
      window.wpObject?.tool_data?.data?.F56 != null
        ? window.wpObject?.tool_data?.data?.F56
        : 0, //  liter diesel per år
    H56:
      window.wpObject?.tool_data?.data?.H56 != null
        ? window.wpObject?.tool_data?.data?.H56
        : 0, // liter diesel per ha

    // Arbetstimmar och maskintimmar per ha fram till och med lager
    F58:
      window.wpObject?.tool_data?.data?.F58 != null
        ? window.wpObject?.tool_data?.data?.F58
        : 0, //  arbetstim/ha grovfoder
    H58:
      window.wpObject?.tool_data?.data?.H58 != null
        ? window.wpObject?.tool_data?.data?.H58
        : 0, // traktortim/ha grovfoder

    // Maskinkostnad per ha
    H60:
      window.wpObject?.tool_data?.data?.H60 != null
        ? window.wpObject?.tool_data?.data?.H60
        : 0, // kr per ha

    // Maskin- och arbetskotnad per ha
    H62:
      window.wpObject?.tool_data?.data?.H62 != null
        ? window.wpObject?.tool_data?.data?.H62
        : 0, // kr per ha
  });

  const handleCalculate = (formData) => {
    if (window?.wpObject?.ajax_url == null) {
      return;
    }

    const requestData = new FormData(form.current);
    requestData.append("action", "wt_ajax_tools_produktionskostnad_grovfoder");

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setResult(response.data);
          setHasResults(true);
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveResults = () => {
    if (window?.wpObject?.ajax_url == null) {
      return;
    }
    const requestData = new FormData(form.current);
    Object.keys(result)
      .filter((cell) => !requestData.has(cell))
      .map((rCell) => requestData.append(rCell, result[rCell]));
    requestData.append("action", "save_tool_produktionskostnad_grovfoder");

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.success) {
          setServerMessages([response.data.message]);
          if (window?.wpObject?.saved_results_url != null) {
            displaySavedAlert();
          }
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="tool-base">
      <ToolHeader />
      <section>
        <form ref={form} onSubmit={handleSubmit(handleCalculate)}>
          <HiddenToolFields />

          {/* Tooltip: */}
          {/* Det finns inget att spara. Klicka på "Beräkna". */}
          <ActionsBar
            hasResults={hasResults}
            onSave={handleSubmit(handleSaveResults)}
            onCalculate={handleSubmit(handleCalculate)}
            serverMessages={serverMessages}
          />

          <FormSection className="1">
            <Wrapper>
              <InputColumn className="1">
                <div className="left-column">
                  <FormElement
                    label="Ange namn"
                    id="B3"
                    register={register}
                    errors={errors?.B3}
                  />
                </div>
                <div className="right-column">
                  <FormElement
                    label="Ange namn för beräkning"
                    id="D3"
                    register={register}
                    errors={errors?.D3}
                  />
                </div>
              </InputColumn>

              <InputColumn className="inputColumns">
                <div className="left-column">
                  <FormElement
                    label="Totalt brukad areal exkl betesmark"
                    id="D5"
                    unit="ha"
                    tooltip="Lägg in totala arealen som din växtodling omfattar exklusive betesmark"
                    register={register}
                    errors={errors?.D5}
                  />

                  <FormElement
                    label="Behov ts-skörd grovfoder totalt exkl bete"
                    id="D6"
                    unit="kg ts"
                    register={register}
                    errors={errors?.D6}
                  />

                  <FormElement
                    label="Ts-skörd grovfoder per ha"
                    id="D7"
                    unit="kg ts"
                    value={result.D7 != null ? result.D7 : 0}
                  />

                  <FormElement
                    label="Arbetstid totalt grovfoder fram till och med lager"
                    id="D8"
                    unit="tim"
                    register={register}
                    tooltip="Ofta krävs det fler arbetstimmar än de du gör på traktorn"
                    errors={errors?.D8}
                  />

                  <FormElement
                    label="Arbetskostnad"
                    id="D9"
                    unit="kr"
                    tooltip="Vi rekommenderar inte att du kräver lägre ersättning än 250 kr bruttokostnad per timme"
                    register={register}
                    errors={errors?.D9}
                  />
                </div>

                <div className="right-column">
                  {/* <div> */}
                  <FormElement
                    label="varav grovfoder"
                    id="H5"
                    unit="ha"
                    tooltip="Här anger du grovfoderareal som sköts med maskiner"
                    register={register}
                    errors={errors?.H5}
                  />

                  <FormElement
                    label="skörd i kg blöt vara"
                    id="H6"
                    unit="kg"
                    value={result.H6}
                  />

                  <FormElement
                    label="Ts-halt skörd (snitt)"
                    id="H7"
                    unit="%"
                    register={register}
                    errors={errors?.H7}
                    tooltip="Ange ett medel för samtliga skördar"
                  />

                  <FormElement
                    label="Traktortimmar grovfoder"
                    id="H8"
                    unit="tim"
                    register={register}
                    errors={errors?.H8}
                    tooltip="Uppskatta antal traktortimmar som krävs för att sköta din grovfoderareal inklusive tid för etablering (plöja, harva, så) per år"
                  />
                  {/* </div> */}
                </div>
              </InputColumn>
            </Wrapper>
          </FormSection>

          <FormSection className="2">
            <Wrapper>
              <header className="">
                <h4 className="column large-8 medium-12">
                  Förnödenheter och arealkostnad per år
                </h4>
                <h5 className="column large-2 hide-for-mobile">
                  Totalt per år
                </h5>
                <h5 className="column large-2 hide-for-mobile">
                  Kostnad per kg ts
                </h5>
              </header>

              <div className="">
                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F13"
                    label="Areal/Arrendekostnad totalt för all areal"
                  >
                    <Error message={errors?.F13?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Här anger du kostnad för all areal som du brukar med maskiner arrende och krav på ersättning för ägd areal"
                    >
                      <Input type="text" {...register("F13")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H13}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F14"
                    label="Utsäde och frö till grovfoder"
                  >
                    <Error message={errors?.F14?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F14")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H14}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F15"
                    label="Handelsgödsel grovfoder"
                  >
                    <Error message={errors?.F15?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F15")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H15}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F16"
                    label="Kalk total kostnad per år"
                  >
                    <Error message={errors?.F16?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Ange kostnad för all areal som din växtodling omfattar"
                    >
                      <Input type="text" {...register("F16")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H16}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F17"
                    label="Bekämpningsmedel totalt"
                  >
                    <Error message={errors?.F17?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Ange kostnad för all areal som din växtodling omfattar"
                    >
                      <Input type="text" {...register("F17")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H17}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F18"
                    label="Tillsatsmedel grovfoder"
                  >
                    <Error message={errors?.F18?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F18")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H18}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F19"
                    label="Plast och nät"
                  >
                    <Error message={errors?.F19?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F19")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H19}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F20"
                    label="Analyser och övriga kostnader grovfoder"
                  >
                    <Error message={errors?.F20?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F20")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H20}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F22"
                    label="Maskinförsäkring"
                  >
                    <Error message={errors?.F22?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F22")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H22}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" register={register("B21")} />
                    <Error message={errors?.B21?.message} />
                    <Error message={errors?.F21?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F21")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H21}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" register={register("B23")} />

                    <Error message={errors?.B23?.message} />
                    <Error message={errors?.F23?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F23")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H23}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                {/* TODO: Add border-top to simulate "divider"/<hr> */}
                <ResultSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Summa förnödenheter och arealkostnad"
                  />
                  <div className="column large-4 medium-6 xsmall-12 results-inputs">
                    <InputWrapper
                      className="column large-6 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.F25}</ResultWrapper>
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H25}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </ResultSection>
              </div>
            </Wrapper>
          </FormSection>

          <FormSection className="3">
            <Wrapper>
              <header className="">
                <h4 className="column large-8 medium-6 small-4">
                  Maskinkostnader
                </h4>
                <h5 className="column large-2 medium-3 small-4 hide-for-mobile">
                  Totalt per år
                </h5>
                <h5 className="column large-2 medium-3 small-4 hide-for-mobile">
                  Kostnad per kg ts
                </h5>
              </header>
              <div className="">
                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F29"
                    label="Värdeminskning maskiner per år"
                  >
                    <Error message={errors?.F29?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F29")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H29}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" {...register("B30")} />

                    <Error message={errors?.B30?.message} />
                    <Error message={errors?.F30?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F30")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H30}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" {...register("B31")} />

                    <Error message={errors?.B31?.message} />
                    <Error message={errors?.F31?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F31")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H31}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F33"
                    label="Diesel lantbruk exklusive entr. skog och inomgård"
                  >
                    <InputWrapper
                      className="small"
                      title="l/tim"
                      toolTip="Är det här en rimlig dieselförbrukning i snitt per traktortimme?"
                    >
                      <ResultWrapper>{result.D33}</ResultWrapper>
                    </InputWrapper>

                    <Error message={errors?.F33?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Lägg in totala arealen som din växtodling omfattar exklusive betesmark"
                    >
                      <Input type="text" {...register("F33")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H33}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>
                <SubSection>
                  <Label
                    className="column large-10 medium-9 small-9 xsmall-12"
                    htmlFor="I33"
                    label="Ange dieselpris efter återbetalning av skatt."
                  >
                    <Error message={errors?.I33?.message} />
                  </Label>
                  <InputWrapper
                    active
                    className="column large-2 medium-3 small-3 xsmall-12"
                    title="kr/l"
                  >
                    <Input type="text" {...register("I33")} />
                  </InputWrapper>
                </SubSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F36"
                    label="Underhåll Maskiner per år"
                  >
                    <Error message={errors?.F36?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Ange kostnad för underhåll av samtlig maskiner på gården"
                    >
                      <Input type="text" {...register("F36")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H36}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" {...register("B37")} />

                    <Error message={errors?.B37?.message} />
                    <Error message={errors?.F37?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F37")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H37}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <LabelInputWrapper className="column large-8 medium-6 xsmall-12">
                    <LabelInput type="text" {...register("B38")} />

                    <Error message={errors?.B38?.message} />
                    <Error message={errors?.F38?.message} />
                  </LabelInputWrapper>

                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F38")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H38}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F40"
                    label="Kapitalkostnad maskiner - ränta"
                  >
                    <Error message={errors?.F40?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                      toolTip="Här kan du lägga in räntekostnaden för de eventuell maskinlån"
                    >
                      <Input type="text" {...register("F40")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H40}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>

                <InputSection>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    htmlFor="F42"
                    label="Inköpta körslor grovfoder"
                  >
                    <Error message={errors?.F42?.message} />
                  </Label>
                  <div className="column large-4 medium-6 xsmall-12">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/år"
                    >
                      <Input type="text" {...register("F42")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H42}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </InputSection>
                <SubSection>
                  <Label
                    className="column large-10 medium-9 small-9 xsmall-12"
                    htmlFor="I42"
                    label="Ange en uppskattad mäng diesel som förbrukats av den som utför körslor på din gård."
                  >
                    <Error message={errors?.I42?.message} />
                  </Label>
                  <InputWrapper
                    active
                    className="column large-2 medium-3 small-3 xsmall-12"
                    title="liter"
                  >
                    <Input type="text" {...register("I42")} />
                  </InputWrapper>
                </SubSection>

                <ResultSection>
                  <Label
                    className="column large-10 xsmall-12"
                    label="Summa maskinkostnader grovfoder fält till och med lager"
                  />
                  <InputWrapper
                    className="column large-2 xsmall-12 results-inputs"
                    title="kr/kg ts"
                  >
                    <ResultWrapper>{result.H44}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>
              </div>
            </Wrapper>
          </FormSection>

          {/* RESULTS --------------------------------------------------------------------------------- */}
          <FormSection className="4">
            <Wrapper>
              <header className="column">
                <h4>Resultat</h4>
              </header>
              <div className="">
                <ResultSection final>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Summa produktionskostnad grovfoder fält till och med lager exkl arbete"
                  />
                  <InputWrapper
                    className="column large-4 medium-6 xsmall-12"
                    title="kr/kg ts"
                  >
                    <ResultWrapper>{result.H46}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>
                <SubSection final>
                  <Label
                    className="column large-10 xsmall-12"
                    label="Arbetskostnad"
                  />
                  <div className="column large-2 medium-6 xsmall-12 subsection-inputs">
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr"
                    >
                      <ResultWrapper>{result.F48}</ResultWrapper>
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H48}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </SubSection>

                <ResultSection final red>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Summa produktionskostnad grovfoder fält utan stöd"
                  />
                  <InputWrapper
                    className="column large-4 medium-6 xsmall-12"
                    title="kr/kg ts"
                  >
                    <ResultWrapper>{result.H50}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>
                <SubSection final>
                  <Label
                    className="column large-10 xsmall-12"
                    htmlFor="F52"
                    label="Arealknutna stöd totalt"
                  >
                    <Error message={errors?.F52?.message} />
                  </Label>
                  <div className="column large-2 medium-6 xsmall-12 subsection-inputs">
                    <InputWrapper
                      active
                      className="column large-6 medium-12 xsmall-12"
                      title="kr"
                    >
                      <Input type="text" {...register("F52")} />
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="kr/kg ts"
                    >
                      <ResultWrapper>{result.H52}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </SubSection>

                <ResultSection final red>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Summa produktionskostnad grovfoder fält minskad med arealknutna stöd"
                  />
                  <InputWrapper
                    className="column large-2 medium-4 xsmall-12"
                    title="kr/kg ts"
                  >
                    <ResultWrapper>{result.H54}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>

                <ResultSection final>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Dieselförbukning totalt och per ha grovfoder till och med lager"
                  />
                  <div className="column large-4 medium-6 xsmall-12 results-inputs">
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="liter diesel per år"
                    >
                      <ResultWrapper>{result.F56}</ResultWrapper>
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="liter diesel per ha"
                    >
                      <ResultWrapper>{result.H56}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </ResultSection>

                <ResultSection final>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Arbetstimmar och maskintimmar per ha fram till och med lager"
                  />
                  <div className="column large-4 medium-6 xsmall-12 results-inputs">
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="arbetstim/ha grovfoder"
                    >
                      <ResultWrapper>{result.F58}</ResultWrapper>
                    </InputWrapper>
                    <InputWrapper
                      className="column large-6 medium-12 xsmall-12"
                      title="traktortim/ha grovfoder"
                    >
                      <ResultWrapper>{result.H58}</ResultWrapper>
                    </InputWrapper>
                  </div>
                </ResultSection>

                <ResultSection final>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Maskinkostnad per ha"
                  />
                  <InputWrapper
                    className="column large-4 medium-6 xsmall-12"
                    title="kr per ha"
                  >
                    <ResultWrapper>{result.H60}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>

                <ResultSection final>
                  <Label
                    className="column large-8 medium-6 xsmall-12"
                    label="Maskin- och arbetskotnad per ha"
                  />
                  <InputWrapper
                    className="column large-4 medium-6 xsmall-12"
                    title="kr per ha"
                  >
                    <ResultWrapper>{result.H62}</ResultWrapper>
                  </InputWrapper>
                </ResultSection>
              </div>
            </Wrapper>
          </FormSection>

          <ActionsBar
            hasResults={hasResults}
            onSave={handleSubmit(handleSaveResults)}
            onCalculate={handleSubmit(handleCalculate)}
            serverMessages={serverMessages}
          />
        </form>
      </section>
    </div>
  );
}

export default Grovfodret;
